






























import { Component, Vue } from 'vue-property-decorator';

import IndexPageDailyReportCard from '@/pages/index/pages/index/components/IndexPageDailyReportCard.vue';
import IndexPageDateRange from '@/pages/index/pages/index/components/IndexPageDateRange.vue';
import IndexPageFab from '@/pages/index/pages/index/components/IndexPageFab.vue';
import IndexPageTankFieldsShownToggle from '@/pages/index/pages/index/components/IndexPageTankFieldsShownToggle.vue';
import { LocationStore } from '@/store/location';

@Component({
  components: {
    IndexPageDailyReportCard,
    IndexPageDateRange,
    IndexPageFab,
    IndexPageTankFieldsShownToggle,
  },
})
export default class IndexPageContent extends Vue {

  @LocationStore.Bind.State fuels!: LocationStore.State<'fuels'>;

  isFabShown = false;

  async mounted() {
    this.isFabShown = true;
  }

  beforeDestroy() {
    this.isFabShown = false;
  }

  goToNew() {
    if (this.$route.name === 'index') {
      this.$router.push('new');
    }
  }

  get keymap() {
    return {
      'alt+n': this.goToNew,
    };
  }

}
